import Input from './src/input';

module.exports = Input;


// WEBPACK FOOTER //
// ./src/components/input/index.js